import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IKehoachNam } from "../../model/respone/ke-hoach/IKehoachNam";
import { apiClient } from "../apiClient";
export const KE_HOACH_NAM_ENDPOINT = "ke-hoach-nam";
export const keHoachNamApi = {
  SelectAll: () => apiClient.get(`${KE_HOACH_NAM_ENDPOINT}`),
  Insert: (payload: IKehoachNam) => apiClient.post(`${KE_HOACH_NAM_ENDPOINT}`, payload),
  Update: (payload: IKehoachNam) => apiClient.put(`${KE_HOACH_NAM_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${KE_HOACH_NAM_ENDPOINT}/${id}`),
  Deletes: (rq:IIdsRequest) => apiClient.put(`${KE_HOACH_NAM_ENDPOINT}/deletes`, rq),
};
